import Vue from 'vue';
import Vuex from 'vuex';
import { UserModule } from '@/store/modules/UserModule';
import { GradeModule } from '@/store/modules/GradeModule';
import { InstructorModule } from '@/store/modules/InstructorModule';
import { PricingModule } from './modules/PricingModule';
import { SpecialOperatingHoursModule } from "@/store/modules/SpecialOperatingHoursModule";
import { StandardOperatingHoursModule } from "@/store/modules/StandardOperatingHoursModule";
import { VoucherModule } from "@/store/modules/VoucherModule";
import { InstructorTableModule } from '@/store/modules/InstructorTableModule';
import { TransactionModule } from "@/store/modules/TransactionModule";
import { BalanceModule } from "@/store/modules/BalanceModule";
import { NotificationModule } from "@/store/modules/NotificationModule";
import { KidSchoolModule } from "@/store/modules/KidSchoolModule";
import { ActivityLogModule } from "@/store/modules/ActivityLogModule";
import { ContractModule } from "@/store/modules/ContractModule";
import { DocumentModule } from "@/store/modules/DocumentModule";
import { ReceiptModule } from "@/store/modules/ReceiptModule";
Vue.use(Vuex);
export default new Vuex.Store({
    modules: {
        user: UserModule,
        grade: GradeModule,
        instructor: InstructorModule,
        pricing: PricingModule,
        specialOperatingHours: SpecialOperatingHoursModule,
        standardOperatingHours: StandardOperatingHoursModule,
        instructorTable: InstructorTableModule,
        voucher: VoucherModule,
        transaction: TransactionModule,
        balance: BalanceModule,
        notification: NotificationModule,
        kidSchool: KidSchoolModule,
        activityLog: ActivityLogModule,
        contract: ContractModule,
        document: DocumentModule,
        receipt: ReceiptModule,
    },
    state: {
        appLoading: true,
    },
    mutations: {
        appLoading(state, value) {
            state.appLoading = value;
        },
    },
    actions: {
        startLoading(context) {
            context.commit('appLoading', true);
        },
        stopLoading(context) {
            context.commit('appLoading', false);
        },
    },
    getters: {
        isLoading: (state) => {
            return state.appLoading;
        },
    },
});
